import { SVGProps } from 'react'

export const Shape = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="27" height="34" fill="none" viewBox="0 0 27 34" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13.5 34l-9.546-9.958c-5.272-5.5-5.272-14.417 0-19.917 5.272-5.5 13.82-5.5 19.092 0 5.272 5.5 5.272 14.417 0 19.917L13.5 34z"
      clipRule="evenodd"
    ></path>
  </svg>
)
